import { IconRepeat as TablerIconRepeat } from '@tabler/icons-react';

import { createOutlineIcon } from '@/components/icon/createOutlineIcon';

export const IconRepeat = /*#__PURE__*/ createOutlineIcon(TablerIconRepeat, 'IconRepeat');
